import { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "eh_cookie_consent";

export const CookieConsent = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  if (choice) return null;
  const save = (v) => {
    localStorage.setItem(KEY, v);
    setChoice(v);
    if (v === "all") window.loadGA?.();
  };
  return (
    <div role="region" aria-label="Cookie consent" data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 right-24 sm:right-auto sm:max-w-sm z-50 rounded-xl bg-white border border-[#E2E8F0] shadow-xl px-4 py-3 no-print fade-up">
      <div className="flex items-center gap-3">
        <Cookie className="hidden sm:block h-5 w-5 text-[#03A896] shrink-0" aria-hidden />
        <div className="min-w-0">
          <p className="text-xs text-[#334155] leading-snug">
            We use cookies for essential features and, with consent, analytics.{" "}
            <Link to="/cookie-policy" className="text-[#027A6D] underline" data-testid="cookie-policy-link">Cookie Policy</Link>
          </p>
          <div className="flex flex-wrap gap-2 mt-2">
            <button onClick={() => save("all")} data-testid="cookie-accept-btn" className="rounded-full bg-[#0B2150] text-white px-3 py-1 text-xs font-semibold hover:bg-[#03A896] transition-colors">Accept all</button>
            <button onClick={() => save("essential")} data-testid="cookie-essential-btn" className="rounded-full border border-[#0B2150] text-[#0B2150] px-3 py-1 text-xs font-semibold hover:bg-slate-50">Essential only</button>
          </div>
        </div>
      </div>
    </div>
  );
};
